import { lowHeightScreens, mediumScreens, smallScreens, largeWidthScreen } from 'components/common/fontElements';
import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

const sidePadding = '40px';
const reducedSidePadding = '35px';

export const Container = styled.div`
  background-color: ${colors.darkWhite1};
  overflow: auto;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'header'
    'section';
`;

export const BlueBar = styled.div`
  height: 7px;
  width: 100%;
  background-color: ${colors.darkWhite1};
`;

export const InnerSection = styled.div`
  padding: 10px ${sidePadding} 30px;
`;

export const Section = styled.div`
  background-color: ${colors.baseBackground};
  grid-area: section;
  grid-row: span 2;
  overflow-y: scroll;
`;

export const HeaderSection = styled.div`
  padding: 25px ${sidePadding};
  background-color: ${colors.baseBackground};
  border-bottom: 1px solid ${colors.lightGray6};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  grid-area: header;

  img {
    margin-right: 15px;
  }

  @media screen and (max-width: ${largeWidthScreen}) {
    padding: 30px ${reducedSidePadding};
  }
  @media screen and (max-height: ${lowHeightScreens}) {
    padding: 20px ${reducedSidePadding};
  }
`;

export const CloseIcon = styled.img`
  position: absolute;
  top: 15px;
  right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

export const Title = styled.p`
  font-family: Lato;
  font-size: 15px;
  color: ${colors.black1};
  margin-bottom: 0px;
  font-weight: bold;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 14px;
  }
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
`;

export const AlertHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  margin-bottom: 8px;
`;

export const AlertTitle = styled.p`
  font-weight: bold;
  margin: 0px;
  padding: 0px;
  font-size: 13px;
  line-height: 1;
  color: ${colors.purple1};
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 10px;
  }
`;

export const AlertContent = styled.div`
  font-size: 12px;
  margin-top: 20px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }

  > p {
    margin-bottom: 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AlertButton = styled.button`
  background-color: ${colors.blue1};
  color: ${colors.whiteText};
  border-radius: 3px;
  border: 0px;
  font-size: 9px;
  padding: 10px 20px;
  outline: none;
  transition: 0.3s;
  &:hover {
    background-color: ${colors.blue2};
  }
`;

export const AcknowledgeButton = styled(AlertButton)`
  margin: 20px 0px 10px;
`;

export const AlertNote = styled(AlertTitle)`
  color: ${colors.red};
  margin-top: 20px;
`;
